// minimum js that needs to load synchronously, before we load all js files in an async manner
require("jquery");
global.jQuery, global.$ = require("jquery");